import { Input } from '@/components/shadcn/input'
import type { PropertyEditorProps } from '@/lib/action-modules/registry/subtypes/types'

// Dates are stored as ISO strings; the native date input works on `yyyy-MM-dd`.
export default function DatePropertyEditor(props: PropertyEditorProps) {
  const raw = typeof props.value === 'string' ? props.value : ''
  const dateValue = raw ? raw.slice(0, 10) : ''

  return (
    <Input
      type="date"
      value={dateValue}
      onChange={e => props.onChanged(e.target.value ? new Date(e.target.value).toISOString() : undefined)}
    />
  )
}
